export const createDefaultPagination = (size = 10, currentPage = 1, totalElements = 0) => ({
  size,
  currentPage,
  totalElements,
});
